import React from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';

import { formatTitle, formatDescription } from '../utils/meta-tags';
import { joinValidStrings, removeLeadingSlash } from '../utils/string';
import { getSlug } from '../utils/url';

const namedTags = (names, content) => (content ? names.map(name => ({ name, content })) : []);

const propertyTag = (property, content) => ({ property, content });

const dcAuthorTags = (authors = []) => authors.map(({ firstName, lastName }) => ({
  name: 'dc.creator',
  content: joinValidStrings([firstName, lastName], ' ')
}));

const dcIdentifierTags = (identifiers = {}) => ['doi', 'pmid']
  .reduce((tags, identifier) => {
    const value = identifiers[identifier];

    return value ? tags.concat({
      name: 'dc.identifier',
      content: `${identifier}:${identifiers[identifier]}`
    }) : tags;
  }, []);

const pageRegex = /^\s*(\d+)\s*[~,-]+\s*(\d+)\s*$/;
const pagesTags = (pages) => {
  if (!pages) return [];
  const [, firstPage, lastPage] = pages.match(pageRegex) || [];

  if (!firstPage || !lastPage || lastPage < firstPage) return [];

  return [
    ...namedTags(['prism.startingPage'], firstPage),
    ...namedTags(['prism.endingPage'], lastPage)
  ];
};

const DocumentMeta = ({
  url, doc, doc: {
    title,
    keywords = [],
    year,
    identifiers = {},
    source,
    abstract,
    authors,
    publisher,
    pages,
    volume,
    issue
  }
}) => (
  <Helmet
    title={formatTitle(title)}
    meta={[
      ...namedTags(['dc.format'], 'text/html'),
      ...namedTags(['prism.publicationName'], source),
      ...namedTags(['dc.publisher'], publisher),
      ...namedTags(['dc.title', 'twitter:title'], title),
      ...namedTags(['dc.date', 'prism.publicationDate'], year),
      ...namedTags(['prism.volume'], volume),
      ...namedTags(['prism.number'], issue),
      ...dcAuthorTags(authors),
      ...pagesTags(pages),
      ...dcIdentifierTags(identifiers),
      ...namedTags(['dc.issn', 'prism.issn'], identifiers.issn),
      ...namedTags(['description', 'twitter:description'], formatDescription(doc)),
      ...namedTags(['keywords'], keywords.join(', ')),
      ...namedTags(['twitter:card'], 'summary'),
      ...namedTags(['twitter:site'], '@mendeley_com'),
      propertyTag('og:description', abstract),
      propertyTag('og:url', url),
      propertyTag('og:title', title)
    ]}
  >
    <link rel="canonical" href={url} />
  </Helmet>
);

// Majority of logic lifted from monolith site.
const DocumentMetaContainer = ({ baseURL, doc }) => (
  <DocumentMeta doc={doc} url={`${baseURL}${removeLeadingSlash(getSlug(doc.link))}`} />
);

const mapStateToProps = ({ location: { baseURL } }) => ({ baseURL });

export default connect(mapStateToProps)(DocumentMetaContainer);



// WEBPACK FOOTER //
// ./src/universal/ui/components/DocumentMeta.js